var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 250,
    viewBox: "0 0 200 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H200V250H0V0Z",
    fill: "url(#paint0_linear_1_42)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.001 142.779L28.591 130.923C32.371 137.624 35.809 143.294 44.056 143.294C51.961 143.294 56.946 140.202 56.946 128.174V46.376H81.003V128.514C81.003 153.431 66.397 164.773 45.087 164.773C25.842 164.773 14.671 154.806 9 142.777L9.001 142.779ZM94.07 140.201L113.658 128.86C118.815 137.281 125.517 143.467 137.373 143.467C147.342 143.467 153.698 138.483 153.698 131.609C153.698 123.361 147.168 120.439 136.17 115.629L130.157 113.049C112.8 105.662 101.287 96.382 101.287 76.792C101.287 58.748 115.034 45 136.515 45C151.809 45 162.807 50.328 170.711 64.247L151.979 76.277C147.854 68.888 143.388 65.967 136.514 65.967C129.468 65.967 125 70.435 125 76.277C125 83.494 129.468 86.417 139.778 90.885L145.792 93.462C166.242 102.227 177.755 111.162 177.755 131.266C177.755 152.92 160.743 164.776 137.888 164.776C115.549 164.776 101.114 154.122 94.069 140.202",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_42",
    x1: 0,
    y1: 0,
    x2: 243.902,
    y2: 195.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D800"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/Javascript.8288a894a35f921f4f94824b2c578fcf.svg";
export { ForwardRef as ReactComponent };